export type AyaPhaseKey = 'analyzed' | 'searching' | 'writing' | 'done';

export interface AyaProgressPhase {
  key: AyaPhaseKey;
  label: string;
  state: 'pending' | 'active' | 'done' | 'skipped';
}

export interface AyaSearchStep {
  id: string;
  label: string;
  query?: string;
  done: boolean;
}

export function initialAyaPhases(): AyaProgressPhase[] {
  return [
    { key: 'analyzed', label: 'Analyzed query', state: 'active' },
    { key: 'searching', label: 'Searching literature', state: 'pending' },
    { key: 'writing', label: 'Thinking', state: 'pending' },
    { key: 'done', label: 'Done', state: 'pending' },
  ];
}

/** Run / queue lifecycle tokens — not user-facing progress copy. */
export function isRunLifecycleStatus(text: string): boolean {
  const t = text.trim().toLowerCase();
  return (
    t === 'running' ||
    t === 'queued' ||
    t === 'pending' ||
    t === 'in_progress' ||
    t === 'processing' ||
    t === 'active' ||
    t === 'completed' ||
    t === 'failed' ||
    t === 'cancelled'
  );
}

export function mapPhaseKey(raw: string): AyaPhaseKey | null {
  const s = raw.toLowerCase();
  if (/analy|triage|rout|plan|understand/.test(s)) return 'analyzed';
  if (/skip/.test(s) && /search|research|literat/.test(s)) return 'searching';
  if (/search|research|literat|pubmed|guideline/.test(s)) return 'searching';
  if (/writ|answer|generat|compos|draft|agent/.test(s)) return 'writing';
  if (/done|complete|finish/.test(s)) return 'done';
  return null;
}

export function advanceAyaPhases(
  prev: AyaProgressPhase[],
  key: AyaPhaseKey,
  opts?: { skipped?: boolean; label?: string }
): AyaProgressPhase[] {
  const order: AyaPhaseKey[] = ['analyzed', 'searching', 'writing', 'done'];
  const idx = order.indexOf(key);
  return prev.map((p) => {
    const pIdx = order.indexOf(p.key);
    if (p.key === key) {
      return {
        ...p,
        label:
          opts?.label ??
          (opts?.skipped && key === 'searching' ? 'Skipped literature search' : p.label),
        state: opts?.skipped ? 'skipped' : 'active',
      };
    }
    if (pIdx < idx && p.state !== 'skipped') {
      return { ...p, state: 'done' };
    }
    return p;
  });
}
